import {Api} from "../api/api";
import {getCurrentUser, renderElement} from "../utils/common";

const getTimeTemplate = (user, date, minutes, hours, seconds, taskId, timerId, userType) => `<li class="time__modal-item js-time-item">
    <div class="time__modal-responsible responsible">
      <div class="responsible__img">
        <img src="${user.img}" width="23" height="23" alt="" class="responsible__icon">
      </div>
      <p class="responsible__name responsible__name--time-modal">
        ${user.name}
      </p>
    </div>
    <form action="/" class="time__modal-form js-modal-form" data-timer-id="${timerId}" data-user-type="${userType}">
    <label class="time__modal-label">
      <input class="time__modal-date js-modal-form-date-${timerId}" name="Timer[date_create]" type="date" value="${date}">
      <span class="visually-hidden">Дата</span>
    </label>
    <div class="time__modal-clock">
      <label for="add-hours-${timerId}" class="visually-hidden">Часы</label>
      <input type="number" name="Timer[hours]" id="add-hours-${timerId}" class="time__modal-input" maxlength="2" value="${hours}">:
      <label for="add-minutes-${timerId}" class="visually-hidden">Минуты</label>
      <input type="number" name="Timer[min]" id="add-minutes-${timerId}" class="time__modal-input" maxlength="2" value="${minutes}">:
      <label for="add-seconds-${timerId}" class="visually-hidden">Секунды</label>
      <input type="number" name="Timer[sec]" id="add-seconds-${timerId}" class="time__modal-input" maxlength="2" value="${seconds}">
    </div>
    ${userType === `admin` ? `<button type="button" class="time__modal-del js-delete-time" aria-label="Удалить" data-timer-id="${timerId}">
      <svg class="time__modal-del-icon" width="16" height="19">
        <use xlink:href="/img/sprite.svg#trash-icon"></use>
      </svg>
    </button>
    <button type="button" class="time__modal-undo js-undo-time" aria-label="Восстановить" data-task-id="${taskId}">
      <svg class="time__modal-undo-icon" width="16" height="18">
        <use xlink:href="/img/sprite.svg#undo-icon"></use>
      </svg>
    </button>` : ``}
    </form>
  </li>`;

export class EditWorkTimeModal {
  _eventEmitter = window.taskEmitter;
  _timerModal;
  _totalHoursElements;
  _totalMinutesElements;
  _totalSecondsElements;
  _addTimerDateElement;
  _addTimerHoursElement;
  _addTimerMinutesElement;
  _addTimerSecondsElement;
  _addTimerForm;
  _timesListElement;
  _itemFormsElements;
  _fp;

  _taskId;

  _urlGetTimers;

  _allItemsCount = 0;

  constructor(flatpickr, taskTimer) {
    this._timerModal = document.querySelector(`.js-time-modal`);
    this._totalHoursElements = document.querySelectorAll(`.js-total-hours`);
    this._totalMinutesElements = document.querySelectorAll(`.js-total-minutes`);
    this._totalSecondsElements = document.querySelectorAll(`.js-total-seconds`);

    this._flatpickr = flatpickr;
    this._timerApi = new Api();
    this._taskTimer = taskTimer;

    this._onTimerFormSubmit = this._onTimerFormSubmit.bind(this);
    this._onTimesListClick = this._onTimesListClick.bind(this);
    this._onItemTimerFormChange = this._onItemTimerFormChange.bind(this);
    this._addItemFormEvents = this._addItemFormEvents.bind(this);
    this._onAddTimer = this._onAddTimer.bind(this);
    this._onShowMoreClick = this._onShowMoreClick.bind(this);
  }

  init() {
    if (this._timerModal) {
      this._addTimerDateElement = this._timerModal.querySelector(`.js-time-add-date`);
      this._addTimerHoursElement = this._timerModal.querySelector(`.js-time-add-hours`);
      this._addTimerMinutesElement = this._timerModal.querySelector(`.js-time-add-minutes`);
      this._addTimerSecondsElement = this._timerModal.querySelector(`.js-time-add-seconds`);
      this._addTimerForm = this._timerModal.querySelector(`.js-time-append`);
      this._timesListElement = this._timerModal.querySelector(`.js-time-list`);
      this._itemFormsElements = this._timerModal.querySelectorAll(`.js-modal-form`);
      this._showMoreElement = this._timerModal.querySelector(`.js-time-show-more`);

      this._taskId = this._addTimerForm.dataset.taskId;
      this._allItemsCount = this._itemFormsElements.length;
      this._urlGetTimers = this._timerModal.dataset.urlGetTimers;

      this._initialFlatpickr();

      this._itemFormsElements.forEach(this._addItemFormEvents);
      this._addTimerHoursElement.addEventListener(`input`, this._onTimeTextFieldInput);
      this._addTimerMinutesElement.addEventListener(`input`, this._onTimeTextFieldInput);
      this._addTimerSecondsElement.addEventListener(`input`, this._onTimeTextFieldInput);
      this._addTimerHoursElement.addEventListener(`change`, this._onTimeTextFieldChange);
      this._addTimerMinutesElement.addEventListener(`change`, this._onTimeTextFieldChange);
      this._addTimerSecondsElement.addEventListener(`change`, this._onTimeTextFieldChange);
      this._addTimerForm.addEventListener(`submit`, this._onTimerFormSubmit);
      this._timesListElement.addEventListener(`click`, this._onTimesListClick);

      if (this._showMoreElement) {
        this._showMoreElement.addEventListener(`click`, this._onShowMoreClick);
      }

      this._eventEmitter.on(`timerModal.addItem`, this._onAddTimer);

    }
  }

  _addItemFormEvents(form) {
    const timeInputElements = form.querySelectorAll(`input[type="number"]`);

    form.addEventListener(`change`, this._onItemTimerFormChange);
    timeInputElements.forEach((inputElement) => {
      inputElement.addEventListener(`input`, this._onTimeTextFieldInput);
      inputElement.addEventListener(`change`, this._onTimeTextFieldChange);
    });
  }

  _initialFlatpickr() {
    this._fp = this._flatpickr(`.js-time-add-date`, {
      altInput: true,
      altFormat: "j M",
      dateFormat: "Y-m-d",
      monthSelectorType: "static",
      defaultDate: new Date(),
      maxDate: new Date(),
      static: true,
    });

    this._flatpickr(`.js-modal-form-date`, {
      altInput: true,
      altFormat: "D, j F",
      dateFormat: "Y-m-d",
      monthSelectorType: "static",
      disableMobile: true,
      maxDate: new Date(),
    });
  }

  _addTimeItem({user, date, hours, minutes, seconds, taskId, timerId, userType, isPrepend = true}) {
    const element = renderElement(this._timesListElement, getTimeTemplate(user, date, minutes, hours, seconds, taskId, timerId, userType), isPrepend);
    this._flatpickr(`.js-modal-form-date-${timerId}`, {
      altInput: true,
      altFormat: "D, j F",
      dateFormat: "Y-m-d",
      monthSelectorType: "static",
      disableMobile: true,
      maxDate: new Date(),
    });

    if (userType === `admin`) {
      this._addItemFormEvents(element.querySelector(`.js-modal-form`));
    }
  }

  _updateTotalTimer({hours, min, sec}) {
    this._totalHoursElements.forEach((totalHoursElement) => (totalHoursElement.textContent = hours));
    this._totalMinutesElements.forEach((totalMinutesElement) => (totalMinutesElement.textContent = min));
    this._totalSecondsElements.forEach((totalMinutesElement) => (totalMinutesElement.textContent = sec));
  }

  _removeTime(buttonElement) {
    const timerId = buttonElement.dataset.timerId;

    this._timerApi
      .removeTimer(timerId)
      .then((data) => {
        const parent = buttonElement.closest(`.js-time-item`);
        const undoButtonElement = parent.querySelector(`.js-undo-time`);

        buttonElement.classList.add(`time__modal-del--hide`);
        undoButtonElement.classList.add(`time__modal-undo--show`);
        parent.classList.add(`time__modal-item--deleted`);
        this._updateTotalTimer(data);
      })
      .then(() => {
        this._taskTimer.updateTimer();
      });
  }

  _changeDataTimerIdOnItem(itemFormElement, timerId) {
    itemFormElement.dataset.timerId = timerId;
    itemFormElement.querySelector(`[data-timer-id]`).dataset.timerId = timerId;
  }

  _undoRemoveTime(buttonElement) {
    const taskId = buttonElement.dataset.taskId;
    const parent = buttonElement.closest(`.js-time-item`);
    const formElement = parent.querySelector(`.js-modal-form`);

    const formData = new FormData(formElement);

    this._timerApi
      .addTimer(formData, taskId)
      .then((data) => {
        const removeButtonElement = parent.querySelector(`.js-delete-time`);

        buttonElement.classList.remove(`time__modal-undo--show`);
        removeButtonElement.classList.remove(`time__modal-del--hide`);
        parent.classList.remove(`time__modal-item--deleted`);
        this._updateTotalTimer(data);

        this._changeDataTimerIdOnItem(formElement, data.timerId);
      })
      .then(() => {
        this._taskTimer.updateTimer();
      });
  }

  _onTimeTextFieldInput(evt) {
    const self = evt.currentTarget;

    if (self.value.length > self.maxLength) {
      self.value = self.value.slice(0, self.maxLength);
    }

    if (!self.value.length) {
      self.value = `00`;
    }

    if (self.name !== `Timer[hours]`) {
      self.value = self.value > 59 ? 59 : self.value;
    }
  }

  _onTimeTextFieldChange(evt) {
    const self = evt.currentTarget;

    if (self.value.length === 1) {
      self.value = `0${self.value}`;
    }
  }

  _onTimesListClick(evt) {
    const target = evt.target;
    switch (true) {
      case target.classList.contains(`js-delete-time`) || Boolean(target.closest(`.js-delete-time`)):
        const removeButtonElement = target.classList.contains(`js-delete-time`) ? target : target.closest(`.js-delete-time`);
        this._removeTime(removeButtonElement);
        break;
      case target.classList.contains(`js-undo-time`) || Boolean(target.closest(`.js-undo-time`)):
        const undoButtonElement = target.classList.contains(`js-undo-time`) ? target : target.closest(`.js-undo-time`);
        this._undoRemoveTime(undoButtonElement);
        break;
    }
  }

  _onItemTimerFormChange(evt) {
    evt.preventDefault();

    const self = evt.currentTarget;
    const formData = new FormData(self);
    const timerId = self.dataset.timerId;

    this._timerApi
      .updateTimer(formData, timerId)
      .then((data) => {
        this._updateTotalTimer(data);
      })
      .then(() => {
        this._taskTimer.updateTimer();
      });
  }

  _resetForm(form) {
    form.classList.remove(`time__modal-append--show`);
    form.reset();
    this._fp.setDate(new Date());
  }

  _appendFormData(formData) {
    formData.append(this._addTimerDateElement.name, this._addTimerDateElement.value);
    formData.append(this._addTimerHoursElement.name, this._addTimerHoursElement.value ? this._addTimerHoursElement.value : `00`);
    formData.append(this._addTimerMinutesElement.name, this._addTimerMinutesElement.value ? this._addTimerMinutesElement.value : `00`);
    formData.append(this._addTimerSecondsElement.name, this._addTimerSecondsElement.value ? this._addTimerSecondsElement.value : `00`);
  }

  _onAddTimer({user, date, hours, minutes, seconds, taskId, timerId, totalTime}) {
    this._addTimeItem({
      user, date, hours, minutes, seconds, taskId, timerId, userType: `admin`,
    });

    this._updateTotalTimer(totalTime);
  }

  async _onShowMoreClick() {
    const res = await this._timerApi.customQuery(`${this._urlGetTimers}&count=${this._allItemsCount + 1}`, {});

    if (res.code === 200) {
      res.answer.forEach(({responsible, date, time, timerId, userType}) => {
        this._addTimeItem({
          user: responsible,
          date: date,
          hours: time.hours,
          minutes: time.minutes,
          seconds: time.seconds,
          taskId: this._taskId,
          timerId: timerId,
          userType: userType,
          isPrepend: false,
        });
      });

      this._allItemsCount += res.answer.length;

      if (this._allItemsCount >= +this._showMoreElement.dataset.countTimers) {
        this._showMoreElement.remove();
      }
    }
  }

  _onTimerFormSubmit(evt) {
    evt.preventDefault();

    const self = evt.currentTarget;
    const formData = new FormData();

    this._appendFormData(formData);

    this._timerApi
      .addTimer(formData, self.dataset.taskId)
      .then((data) => {
        const date = this._addTimerDateElement.value;
        const hours = this._addTimerHoursElement.value ? this._addTimerHoursElement.value : `00`;
        const minutes = this._addTimerMinutesElement.value ? this._addTimerMinutesElement.value : `00`;
        const seconds = this._addTimerSecondsElement.value ? this._addTimerSecondsElement.value : `00`;

        this._addTimeItem({
          user: getCurrentUser(),
          date,
          hours,
          minutes,
          seconds,
          taskId: this._taskId,
          timerId: data.timerId,
          userType: `admin`,
        });
        this._updateTotalTimer(data);
        this._resetForm(self);
      })
      .then(() => {
        this._taskTimer.updateTimer();
      });
  }
}
